import { PanelProps } from './models/NQTFooterPanel.interfaces';

export const NQTFooterPanel = ({
  title,
  children,
  isActive,
  onShow
}:PanelProps): JSX.Element => {


  return (
    <>
      <section className='nqt-footer-panel'>
        <div className='accordion-it--additional-resources g-2'>
          <button onClick={onShow}
            aria-expanded={isActive}
            aria-label={`Toggle ${title} nqt-footer--options`}>
            <h3 className='accordion-button--additional-resources' >{isActive ? '- ' : '+'} {title}</h3>
          </button>
        </div>
        
        {isActive ? (
          <div className='accordion-item--additional-resources'>{children}</div>
        ) : ( 
          <></>
        )}
      </section>
    </>
  );
};

export default NQTFooterPanel;